// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.azure.ts`.
// The list of file replacements can be found in `angular.json`.

const keycloakConfig = {
  url: 'https://easytrack-sso.aero.bridgestone/auth',
  realm: 'EasyTrack-Test',
  clientId: 'easy-front',
};

export const environment = {
  baseUrl: 'https://easytrack-preprod-api.aero.bridgestone/api/v1',
  baseWS: 'wss://easytrack-preprod-api.aero.bridgestone/api/v1',
  //baseUrl: "http://127.0.0.1:18080/api",
  //baseWS: "wss://127.0.0.1:18080/api",
  production: true,
  emailFrom: 'noreply@bridgestone-bae.com',
  emailTo: 'solutions@bridgestone-bae.com',
  assets: {},
  hideDashboard: false,
  keycloak: keycloakConfig,
  headers: {'Content-Type': 'application/json'},
  redirectUri: 'https://easytrack-preprod-admin.aero.bridgestone/',
  //redirectUri: "http://127.0.0.1:4200/",
  babelApiUrl: 'https://babel-api.aero.bridgestone',
  environment: 'preprod',
  faroUrl: undefined
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
